import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const StepEllipse: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            className={className}
        >
            <circle cx="5" cy="5" r="4.5" fill="transparent" stroke="currentColor" />
        </svg>
    );
};
